// Native Shopify properties; no app service, network request or local storage.
if (!customElements.get('kd-personalization')) {
  customElements.define('kd-personalization', class extends HTMLElement {
    connectedCallback() {
      const style = this.querySelector('[data-engraving-style]');
      const text = this.querySelector('[data-engraving-text]');
      if (!text) return;
      if (!style) {
        const validate = () => text.setCustomValidity(text.required && !text.value.trim() ? 'Enter engraving text, not only spaces.' : '');
        text.oninput = validate;
        validate();
        return;
      }
      const update = () => {
        text.setCustomValidity(text.value.length > 10
          ? 'Use up to 10 characters. Your text has not been changed.'
          : '');
      };
      style.onchange = update;
      text.oninput = update;
      update();
    }
  });
}
